import { render, staticRenderFns } from "./activistyMaterial.vue?vue&type=template&id=2c105c01&scoped=true"
import script from "./activistyMaterial.vue?vue&type=script&lang=js"
export * from "./activistyMaterial.vue?vue&type=script&lang=js"
import style0 from "./activistyMaterial.vue?vue&type=style&index=0&id=2c105c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c105c01",
  null
  
)

export default component.exports